/**
 * Logger Instances
 *
 * This file provides pre-configured logger instances for use throughout the application.
 * Import these instances directly instead of creating new ones in each file.
 */

import { Logger } from './logger';

// Create the main application logger
export const appLogger = Logger.getInstance();

// Create scoped loggers for different parts of the application
export const authLogger = appLogger.createScope('Auth');
export const apiLogger = appLogger.createScope('API');
export const onboardingLogger = appLogger.createScope('Onboarding');
export const navigationLogger = appLogger.createScope('Navigation');
export const workspaceLogger = appLogger.createScope('Workspace');
export const uiLogger = appLogger.createScope('UI');
export const chatLogger = appLogger.createScope('Chat');
export const sessionLogger = appLogger.createScope('Session');
export const fileLogger = appLogger.createScope('File');
export const errorLogger = appLogger.createScope('Error');
export const formLogger = appLogger.createScope('Form');
export const googleDriveLogger = appLogger.createScope('GoogleDrive');
export const oneDriveLogger = appLogger.createScope('OneDrive');
export const dropboxLogger = appLogger.createScope('Dropbox');
export const hubspotLogger = appLogger.createScope('HubSpot');
export const snowflakeLogger = appLogger.createScope('Snowflake');
export const servicenowLogger = appLogger.createScope('ServiceNow');
export const nangoLogger = appLogger.createScope('Nango');
export const profileLogger = appLogger.createScope('Profile');
export const industryLogger = appLogger.createScope('Industry');
export const exportLogger = appLogger.createScope('Export');
export const chatHistoryLogger = appLogger.createScope('ChatHistory');
export const performanceLogger = appLogger.createScope('Performance');
export const securityLogger = appLogger.createScope('Security');

// Default export for backward compatibility
export default appLogger;
